/* Elva Messages — mock data (from reference) */
import type { MsContact, MsHistoryEntry, MsThread, MsTopicKey } from './types';

export const MS_TONE = {
  success: { fg: 'var(--success)',    bg: 'var(--success-tint)' },
  gold:    { fg: 'var(--gold)',       bg: 'var(--gold-tint)' },
  warn:    { fg: 'var(--terracotta)', bg: 'var(--terracotta-tint)' },
  ai:      { fg: 'var(--ai-3)',       bg: 'var(--ai-tint)' },
  info:    { fg: 'var(--info)',       bg: 'var(--info-tint)' },
  neutral: { fg: 'var(--ink-2)',      bg: 'var(--cream-0)' },
};

// Fixed V1 topic vocabulary (SMS spec §2). Tags were removed (spec D8).
export const MS_TOPICS = {
  emergency:         { label: 'Emergency',         color: 'var(--terracotta)' },
  booking:           { label: 'Booking',           color: 'var(--success)' },
  billing:           { label: 'Billing',           color: 'var(--gold)' },
  insurance:         { label: 'Insurance',         color: 'var(--gold)' },
  new_patient:       { label: 'New patient',       color: 'var(--ai-3)' },
  clinical_question: { label: 'Clinical question', color: 'var(--info)' },
  records_forms:     { label: 'Records & forms',   color: 'var(--info)' },
  complaint:         { label: 'Complaint',         color: 'var(--terracotta)' },
  feedback:          { label: 'Feedback',          color: 'var(--ai-3)' },
  spam:              { label: 'Spam',              color: 'var(--ink-3)' },
};

export const MS_CONTACTS: MsContact[] = [];

export const MS_THREADS: MsThread[] = [];

export const MS_HISTORY: Record<string, MsHistoryEntry[]> = {};

export const MS_HEALTH = {
  green: { tone: 'success', label: 'On track' },
  yellow: { tone: 'gold', label: 'Watch' },
  red: { tone: 'warn', label: 'At risk' },
  neutral: { tone: 'neutral', label: 'Idle' },
} as const;
